module.exports = __webpack_public_path__ + "static/concrete-wall-2-44e11fda9e05aada55b501901cdfbc3f.png";